import { DragEvent, useState } from "react";

/**
 * ドラッグ&ドロップでのファイル選択を扱う共通フック。
 * ドロップされたFileListを渡すと onFiles が呼ばれる。
 * 返り値の dropHandlers をドロップ対象の要素にスプレッドし、
 * isDragOver でドラッグ中の見た目のフィードバックを出す。
 */
export function useFileDrop(onFiles: (files: FileList) => void) {
    const [isDragOver, setIsDragOver] = useState(false);

    const onDragOver = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const onDragLeave = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
    };

    const onDrop = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onFiles(e.dataTransfer.files);
        }
    };

    return {
        isDragOver,
        dropHandlers: {
            onDragOver,
            onDragEnter: onDragOver,
            onDragLeave,
            onDrop,
        },
    };
}
